module.exports = __webpack_public_path__ + "static/media/solar-panels-and-wind-generator-HYH74FQ1.e3ff4c77.mp4";